import { combineReducers } from 'redux';
import { authentication } from './authentication.reducer';
import { users } from './users.reducer';
import { alert } from './alert.reducer';
import { alertDate } from './alert-date.reducer.js';
import RequestsReducer from '../containers/Requests/requests.reducer';
// import QuestionsReducer from '../containers/Questions/questions.reducer';
import questionsReducer from '../containers/Questions/store/reducer.js';
// import InformationsReducer from '../containers/Informations/informations.reducer';
import DocumentsReducer from '../containers/Documents/store/reducers/documents.reducer';
import CalendarReducer from './calendar.reducer';
import RecordsReducer from './records.reducer';
import AttachmentsReducer from './attachments.reducer';
import NotesReducer from './notes.reducer';
import newRequestReducer from '../containers/CreateRequest/new-request.reducer';
import newWDocumentReducer from './new-wdocument.reducer';
import newDocumentReducer from '../containers/Documents/store/reducers/new-document.reducer';
import editDocumentReducer from './edit-document.reducer';
import contractorReducer from './contractor.reducer';
import warrantyReducer from './warranty.reducer';
import executeTimeReducer from './execute-time.reducer';
import invoiceReducer from './invoice.reducer';
import serviceReducer from './service.reducer';
import addressReducer from './address.reducer';
import requestListReducer from '../containers/Requests/request-list.reducer';
import documentListReducer from '../containers/Documents/store/reducers/document-list.reducer';
import printerReducer from './printer.reduser';
import exportReducer from './export.reduser';
import appBarReducer from './appbar.reduser';
import expiredRequestsReducer from './expired-requests.reducer';
import notificationReducer from './notification.reducer';
import orgInParamsReduser from './org-in-params.reducer';
import addOrgsReduser from './add-orgs.reducer';
import socketioReduser from './socketio.reducer';
import { filterReducer } from '../containers/Requests/request-filter/model';
import votingReducer from '../containers/Voting/store/reducers/voting.reducer';
import meterReducer from '../containers/Meter/store/reducer/meter.reducer';
import debtsReducer from '../containers/Debts/store/reducers/reducer';
import commentsChatReducer from './commentsChat/commentsChatReducer';
import documentFilterReducer from '../containers/Documents/store/reducers/documentFilterReducer.js';
import documentFilterNewReducer from '../containers/Documents/store/reducers/documentFilterNewReducer.js';
import officesReducer from '../containers/Offices/store/reducers/officesReducer';
import housingStockReducer from '../containers/HousingStock/store/reducers/housingStockReducer';
import filterShutdownReducer from '../containers/Shutdowns/features/filterNew/model/slice.js';
import shutdownReducer from '../containers/Shutdowns/shared/model';
import newCalendarReducer from '../containers/Calendar/store/reducers/calendarReducer';
import requestCardReducer from './requestCardReducer';
import statisticsReducer from '../containers/Statistics/store/reducer';
import itemToCalendarReducer from './itemToCalendarReducer';
import phoneReducer from '../containers/Phone/store/reducer';
import callHistoryReducer from '../containers/CallHistory/store/callHistoryReducer';
import crossPageInteractionsReducer from '../crossPageInteractions/store/reducer.js';
import acceptanceRequestToCalendarReducer from './acceptanceRequestToCalendarReducer.js';
import refreshReducer from './refreshReducer.js';
import informationsReducer from '../containers/NewInformations/store/reducer.js';
import rsoImportReducer from '../containers/HousingStock/pages/ReportRSOPage/store/reducers/rsoImportReducer.js';
import { reducer as roomsAcceptanceReducer } from '../containers/RoomsAcceptance';
import permitsFilterReducer from '../containers/TransportPermits/shared/store/reducer.js';

const reducers = {
  printerStore: printerReducer,
  exportStore: exportReducer,
  appBarStore: appBarReducer,
  requestListStore: requestListReducer,
  documentListStore: documentListReducer,
  recordsStore: RecordsReducer,
  attachmentsStore: AttachmentsReducer,
  notesStore: NotesReducer,
  requestsStore: RequestsReducer,
  // questionsStore: QuestionsReducer,
  questionsStore: questionsReducer,
  // informationsStore: InformationsReducer,
  documentsStore: DocumentsReducer,
  calendarStore: CalendarReducer,
  newRequestStore: newRequestReducer,
  newDocumentStore: newDocumentReducer,
  editDocumentStore: editDocumentReducer,
  newWDocumentStore: newWDocumentReducer,
  contractorStore: contractorReducer,
  warrantyStore: warrantyReducer,
  executeTimeStore: executeTimeReducer,
  invoiceStore: invoiceReducer,
  expiredRequestsStore: expiredRequestsReducer,
  notificationStore: notificationReducer,
  orgInParamsStore: orgInParamsReduser,
  addOrgsStore: addOrgsReduser,
  serviceStore: serviceReducer,
  addressStore: addressReducer,
  socketioStore: socketioReduser,
  votingStore: votingReducer,
  filterStore: filterReducer,
  meterStore: meterReducer,
  debtsStore: debtsReducer,
  authentication: authentication,
  users: users,
  alert: alert,
  alertDateStore: alertDate,
  commentsChatStore: commentsChatReducer,
  documentFilterStore: documentFilterReducer,
  documentFilterNewStore: documentFilterNewReducer,
  officesStore: officesReducer,
  housingStockStore: housingStockReducer,
  rsoImportStore: rsoImportReducer,
  newCalendarStore: newCalendarReducer,
  requestCardStore: requestCardReducer,
  statisticsStore: statisticsReducer,
  itemToCalendarStore: itemToCalendarReducer,
  phoneStore: phoneReducer,
  callHistoryStore: callHistoryReducer,
  crossPageInteractionsStore: crossPageInteractionsReducer,
  acceptanceRequestToCalendarStore: acceptanceRequestToCalendarReducer,
  refreshStore: refreshReducer,
  informationsStore: informationsReducer,
  filterShutdownStore: filterShutdownReducer,
  shutdownStore: shutdownReducer,
  roomsAcceptanceStore: roomsAcceptanceReducer,
  permitsFilterStore: permitsFilterReducer,
};
const rootReducer = combineReducers(reducers);

export default rootReducer;
